export default __webpack_public_path__ + "static/media/lock.0fcd9bb1.svg";